module.exports = __webpack_public_path__ + "static/media/avatar-2.260b368f.svg";